<template>
	<div class="widget-form-header-container width-100 display-flex flex-row flex-align-center flex-justify-space-between">
		<AddNewWidgetElement v-if="showAddNewBlockButton" v-on="$listeners" />
		<!-- leave empty div here because of the space between -->
		<div v-else />
		<WidgetLayoutSettings
			v-on="$listeners"
			:sideBarFocus="sideBarFocus"
			v-if="shouldShowWidgetLayoutSettings"
			:hasEditPermissions="hasEditPermissions"
		/>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import WidgetService from '@/utils/WidgetService';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { canEditWorkflow } from '@/store/modules/workflows/getters';
import AddNewWidgetElement from './WidgetFormHeader/AddNewWidgetElement';
import WidgetLayoutSettings from './WidgetFormHeader/WidgetLayoutSettings';
import { selectedWorkflowId } from '@/store/modules/selectedWorkflow/getters';
export default {
	name: 'WidgetFormHeader',
	components: {
		AddNewWidgetElement,
		WidgetLayoutSettings,
	},
	props: {
		isMiniApp: Boolean,
		sideBarFocus: { type: String },
		miniAppType: { type: String },
	},
	computed: {
		...mapGetters('widgetEditor', ['widgetFields']),
		...mapGettersShorthand({ canEditWorkflow, selectedWorkflowId }),
		shouldShowWidgetLayoutSettings() {
			return WidgetService.shouldShowWidgetLayoutSettings({ miniAppType: this.miniAppType, isMiniApp: this.isMiniApp });
		},
		hasEditPermissions() {
			return this.canEditWorkflow(this.selectedWorkflowId);
		},
		showAddNewBlockButton() {
			return this.hasEditPermissions && !this.isMiniApp && this.widgetFields.length > 0;
		},
	},
};
</script>
